// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IRFnE","footer":"styles_footer__1O429","passCodeTooltip":"styles_passCodeTooltip__2uNUs"};